import fetchMatchingGenerics, { Generic } from '../../../../../api/fetchMatchingGenerics';

// There can be chance we start persisiting it in genie as well
export const onGenericCompositionSearch = (text: string): Promise<Generic[]> => {
    return fetchMatchingGenerics(text).then((res) => {
        return res;
    });
};
